module.exports = __webpack_public_path__ + "media/images/menu/thebe-8b7452faa806435c497e4822a88b8450.jpg";